import { hsl } from 'd3';

const STOCK_STATUS_COLORS: Record<string, string> = {
  instock: '#10B981',
  lowstock: '#F59E0B',
  outofstock: '#EF4444',
  overstock: '#3B82F6'
};

const CATEGORY_COLORS: string[] = [
  '#E8B4D9', '#8B5CF6', '#3B82F6', '#10B981', '#84CC16',
  '#EAB308', '#F59E0B', '#F97316', '#EF4444', '#EC4899'
];

const SERIES_COLORS: string[] = ['#3873C9', '#8D63C3', '#50AD41', '#F4BC2B'];

// Rotating the hue by the golden angle keeps each generated colour far from the ones before it
const GOLDEN_ANGLE_DEGREES = 137.508;
const GENERATED_SATURATION = 0.55;
const GENERATED_LIGHTNESS = 0.5;

export function getCategoryColor(index: number): string {
  return CATEGORY_COLORS[index % CATEGORY_COLORS.length];
}

export function getSeriesColor(index: number): string {
  if (index < SERIES_COLORS.length) return SERIES_COLORS[index];

  const hue = (index * GOLDEN_ANGLE_DEGREES) % 360;
  return hsl(hue, GENERATED_SATURATION, GENERATED_LIGHTNESS).formatHex();
}

export function getStockStatusColor(label: string, index: number): string {
  const key = (label ?? '').toLowerCase().replace(/[^a-z]/g, '');
  return STOCK_STATUS_COLORS[key] ?? getCategoryColor(index);
}